/** Where a request came from; attached to triage and LLM payloads. */
export interface ClientInfo {
  appUrl: string;
  userAgent: string;
  environment: string;
}

export const defaultClientInfo = (): ClientInfo => ({
  appUrl: typeof window !== 'undefined' ? window.location.href : '',
  userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
  environment: process.env.REACT_APP_ENVIRONMENT || 'unknown',
});
